import { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import DashboardLayout from 'prefabsComponents/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import Footer from 'prefabsComponents/Footer';
import DataTable from 'prefabsComponents/Tables/DataTable';
import useFetch from 'hooks/useFetch';
import DefaultCell from 'layouts/pages/orders/order-list/components/DefaultCell';
import DataTableLoader from 'components/DataTableLoader';
import DataTableHeaderOptions from 'components/DataTableHeaderOptions';
import DataTableDocumentActions from 'components/DataTableDocumentActions';
import EditIcon from '@mui/icons-material/Edit';
import CreateNewModal from './CreateNewModal';

const Moneda = () => {
    const { data, isLoading, refetch } = useFetch('/api/finance/currency-types/');
    const [dataTableData, setDataTableData] = useState({ columns: [], rows: [] });
    const [selectedCurrencyType, setSelectedCurrencyType] = useState(null);

    useEffect(() => {
        if(data){
            const renderCell = ({ value }) => <DefaultCell value={value} />;

            const columns = [
                { Header: 'ID', accessor: 'id', Cell: renderCell },
                { Header: 'Nombre', accessor: 'name', Cell: renderCell },
                { Header: 'Acciones', accessor: 'acciones', Cell: renderCell }
            ];
            
            const rows = data.results.map(({ name, id }) => ({ 
                name, 
                id,
                acciones: (
                    <DataTableDocumentActions
                        actions={[{
                            Icon: EditIcon,
                            onClick: () => handleEdit({ name, id }),
                            color: 'primary'
                        }]}
                    />
                )
            }));

            setDataTableData({ columns, rows });
        }
    }, [data]);

    const handleEdit = (currencyType) => {
        setSelectedCurrencyType(currencyType);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <DataTableHeaderOptions
                createNewTitle='Nueva Moneda'
                dataTableData={dataTableData}
                hasFilters={false}
                setSelectedDocument={setSelectedCurrencyType}
                selectedDocument={selectedCurrencyType}
                getData={refetch}
                isLoading={isLoading}
                CreateNewModal={CreateNewModal}
            />
            <Card>
                {isLoading ? (
                    <DataTableLoader />
                ) : (
                    <DataTable
                        table={dataTableData}
                        entriesPerPage={true}
                        canSearch={true}
                        showTotalEntries={true}
                    />
                )}
            </Card>
            <Footer />
        </DashboardLayout>
    );
}

export default Moneda;
